var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFixlink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f4284a;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #222121;\n      }\n\n      .cls-5 {\n        opacity: .1;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "easylan"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    width: 70,
    height: 70,
    rx: 26.25,
    ry: 26.25
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m37.58,39.57c-1.96,7.98-8.89,13.26-17.04,13.26-10.57,0-17.77-8.43-17.77-17.55,0-8.61,6.65-17.45,17.68-17.45s16.22,8.16,17.14,13.44h-9.02c-.96-2.51-3.51-5.88-8.16-5.88-5.79,0-9.02,5.06-9.02,9.84,0,5.1,3.46,10.03,9.07,10.03s7.57-4.51,8.11-5.7h9.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m49.97,18.47v20.37c0,1.14.05,2.73.59,4.06.59,1.32,1.69,2.37,3.78,2.37s3.24-.96,3.74-2.19c.55-1.28.55-2.92.55-4.24v-20.37h8.61v20.37c0,5.65-1.23,8.16-3.37,10.34-2.19,2.23-5.24,3.65-9.43,3.65-2.46,0-6.93-.59-9.71-3.6-2.78-3.05-3.37-5.42-3.37-10.39v-20.37h8.61Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m31.58,40.02v-12.44h-3.04v15.12h8.01v-2.68h-4.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m37.65,27.58v2.39h2.67v-2.39h-2.67Zm0,3.91v11.21h2.67v-11.21h-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m48.63,31.14c-2-.02-3,.96-3.49,1.84.02-.53.02-1,.02-1.49h-2.51v11.21h2.67v-6.2c0-1.57.65-2.83,2.55-2.86,1.88,0,2.43,1.29,2.43,2.96v6.09h2.67v-6.76c0-1.98-.69-4.78-4.35-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m63.06,39.97l-2.64-3.54,4.66-4.94h-3.21l-3.86,4.26v-8.17h-2.67v15.12h2.67v-5.6l4.03,5.6h3.07l-2.04-2.73Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "70 39.97 70 42.7 67.19 42.7 65.16 39.97 70 39.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m8.98,31.49v-.55c0-1.57,1.1-1.57,1.78-1.57v-2.06c-1.92.01-4.45.22-4.45,3.55v.64H0v2.06h6.31v9.16h2.67v-9.16h3.05v9.16h2.67v-11.21h-5.72Zm3.05-3.91v2.39h2.67v-2.39h-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m23.18,36.79l3.76-5.31h-3.19l-2.18,3.45-2.18-3.45h-3.23l3.78,5.31-4.15,5.91h3.25l2.53-3.86,2.51,3.86h3.29l-4.19-5.91Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixlink);
export default __webpack_public_path__ + "static/media/fixlink.50311e3e10efa09cb8afdec8155466f6.svg";
export { ForwardRef as ReactComponent };